import { useState, useEffect } from "react";
import { SACRED_FALLBACK_IMAGE } from "@/lib/sacred-library/utils/image-urls";

const VARIANT_CLASS = {
  deity: "ring-amber-700/30 bg-amber-50/80",
  festival: "ring-indigo-700/25 bg-indigo-50/80",
  vrata: "ring-teal-700/25 bg-slate-50",
  story: "ring-slate-400/30 bg-slate-50",
  sadhana: "ring-teal-600/20 bg-slate-50",
  default: "ring-border/40 bg-muted/30",
};

/**
 * Full sacred topic image (detail pages, dashboard rows).
 */
export function SacredImage({
  src,
  alt,
  variant = "default",
  className = "",
  size = "detail",
  testId,
}) {
  const [url, setUrl] = useState(src || SACRED_FALLBACK_IMAGE);

  // Update state if src prop changes (e.g. after upload or dynamic override fetch)
  useEffect(() => {
    setUrl(src || SACRED_FALLBACK_IMAGE);
  }, [src]);
  const ring = VARIANT_CLASS[variant] || VARIANT_CLASS.default;
  const wrapperClass =
    size === "thumb"
      ? `w-10 h-10 flex-shrink-0 rounded-full ${ring} ring-1`
      : size === "row"
        ? `w-14 h-14 flex-shrink-0 rounded-lg ${ring} ring-2`
        : `w-full ${ring} ring-2 rounded-xl`;

  const imgClass =
    size === "thumb"
      ? "w-full h-full object-contain object-center p-0.5"
      : size === "detail"
        ? "w-full max-h-56 object-contain object-center p-4"
        : size === "row"
          ? "w-full h-full object-contain object-center p-1"
          : "w-full h-full object-contain object-center";

  return (
    <div
      className={`overflow-hidden flex items-center justify-center ${wrapperClass} ${className}`}
      data-testid={testId}
    >
      <img
        src={url}
        alt={alt || "Sacred illustration"}
        className={imgClass}
        loading="lazy"
        decoding="async"
        onError={() => {
          if (url !== SACRED_FALLBACK_IMAGE) setUrl(SACRED_FALLBACK_IMAGE);
        }}
      />
    </div>
  );
}
